import React from 'react';
import { withRouter } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';

import { TaskTypes } from '../../../lib/utils';

const styles = {
  flexRow: {
    display: 'flex',
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignContent: 'center',
  },
  textField: {
    fontWeight: 'bold',
  },
};

function BasePickupTaskModal({
  isOpen, onClose, marketId, vehicles, setOneTask,
}) {
  const humandIds = vehicles.map((vehicle) => vehicle.humanId);
  const humandIdsString = humandIds.length < 6
    ? humandIds.join(', ')
    : `${humandIds.slice(0, 6).join(', ')} and ${humandIds.slice(6).length} others`;

  const setPickupTask = (vehicleList) => {
    if (!vehicleList || !marketId) return;
    const vehicleIds = vehicleList.map((vehicle) => vehicle._id);
    const newTask = {
      marketId,
      task: TaskTypes.PICK_UP,
      assignedVehicleIds: vehicleIds,
    };
    setOneTask(newTask);
  };

  return (
    <Dialog
      maxWidth="xs"
      open={isOpen}
      onClose={onClose}
      fullWidth
    >
      <DialogContent>
        <Grid style={styles.flexRow}>
          <Typography style={styles.textField}>{humandIdsString}</Typography>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          fullWidth
          color="primary"
          variant="contained"
          onClick={() => {
            setPickupTask(vehicles);
            onClose();
          }}
        >
          Request Pickup
        </Button>
      </DialogActions>
    </Dialog>
  );
}

BasePickupTaskModal.defaultProps = {};
BasePickupTaskModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  marketId: PropTypes.string.isRequired,
  vehicles: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
    }).isRequired,
  ).isRequired,
  setOneTask: PropTypes.func.isRequired,
};

const PickupTaskModal = withRouter(BasePickupTaskModal);
export { BasePickupTaskModal, PickupTaskModal };
